import LogisticsCompany from "@/enum/LogisticsCompany";

const LogisticsCompanyNameMap = {
  [LogisticsCompany.ZTO]: "中通快递",

  [LogisticsCompany.ZTO56]: "中通快运",

  [LogisticsCompany.YTO]: "圆通速递",

  [LogisticsCompany.STO]: "申通快递",

  [LogisticsCompany.YUNDA]: "韵达快递",

  [LogisticsCompany.YUNDA56]: "韵达快运",

  [LogisticsCompany.ANE66]: "安能快递",

  [LogisticsCompany.ANE56]: "安能物流",

  [LogisticsCompany.JD_EXPRESS]: "京东快递",

  [LogisticsCompany.JD_HPCP]: "京东大件物流",

  [LogisticsCompany.GTO]: "国通快递",

  [LogisticsCompany.EMS]: "EMS",

  [LogisticsCompany.EYB]: "EMS经济快递",

  [LogisticsCompany.SF]: "顺丰速运",

  [LogisticsCompany.KUAYUE]: "跨越速运",

  [LogisticsCompany.EXFRESH]: "安鲜达",

  [LogisticsCompany.DBL]: "德邦物流",

  [LogisticsCompany.DBKD]: "德邦快递",

  [LogisticsCompany.JIUYESCM]: "九曳供应链",

  [LogisticsCompany.TTKDEX]: "天天快递",

  [LogisticsCompany.ZJS]: "宅急送",

  [LogisticsCompany.POST]: "中国邮政",

  [LogisticsCompany.POSTB]: "邮政快递包裹",

  [LogisticsCompany.POSTS]: "邮政标准快递",

  [LogisticsCompany.HTKY]: "原百世快递(极兔)",

  [LogisticsCompany.BESTQJT]: "百世快运",

  [LogisticsCompany.BEST]: "百世物流",

  [LogisticsCompany.UC]: "优速快递",

  [LogisticsCompany.WXWL]: "万象物流",

  [LogisticsCompany.QFKD]: "全锋快递",

  [LogisticsCompany.LB]: "龙邦快递",

  [LogisticsCompany.UAPEX]: "全一快递",

  [LogisticsCompany.FAST]: "快捷快递",

  [LogisticsCompany.HOAU]: "天地华宇",

  [LogisticsCompany.PJBEST]: "品骏快递",

  [LogisticsCompany.RFD]: "如风达快递",

  [LogisticsCompany.YCKY]: "远成快运",

  [LogisticsCompany.YMDD]: "壹米滴答",

  [LogisticsCompany.SURE]: "速尔快递",

  [LogisticsCompany.SUT56]: "速通物流",

  [LogisticsCompany.CRE]: "中铁快运",

  [LogisticsCompany.AIR]: "亚风",

  [LogisticsCompany.CNEX]: "佳吉快递",

  [LogisticsCompany.FEDEX]: "联邦快递",

  [LogisticsCompany.QRT]: "增益速递",

  [LogisticsCompany.JYMWL]: "加运美速递",

  [LogisticsCompany.XFWL]: "信丰物流",

  [LogisticsCompany.DTW]: "大田物流",

  [LogisticsCompany.DSWL]: "D速物流",

  [LogisticsCompany.CNDTK]: "承诺达特快",

  [LogisticsCompany.YTWL]: "运通物流",

  [LogisticsCompany.CYWL]: "长宇物流",

  [LogisticsCompany.XBWL]: "新邦物流",

  [LogisticsCompany.LWT]: "联昊通",

  [LogisticsCompany.SNWL]: "苏宁物流",

  [LogisticsCompany.NDSD]: "能达速递",

  [LogisticsCompany.BHWL]: "保宏物流",

  [LogisticsCompany.FW]: "发网",

  [LogisticsCompany.CF]: "长发",

  [LogisticsCompany.YC]: "远长",

  [LogisticsCompany.DFH]: "东方汇",

  [LogisticsCompany.FYPS]: "飞远配送",

  [LogisticsCompany.HMZJB]: "黑猫宅急便",

  [LogisticsCompany.ESB]: "E速宝",

  [LogisticsCompany.HQWL]: "华强物流",

  [LogisticsCompany.AXWL]: "安迅物流",

  [LogisticsCompany.TOPSPEED]: "中运全速",

  [LogisticsCompany.HUAQIEX]: "华企快运",

  [LogisticsCompany.DN]: "丹鸟",

  [LogisticsCompany.DSJZ]: "都市节奏",

  [LogisticsCompany.KHWL]: "宽昊物流",

  [LogisticsCompany.SXJD]: "顺心捷达",

  [LogisticsCompany.JT]: "极兔速递",

  [LogisticsCompany.SZKKE]: "京广速递",

  [LogisticsCompany.ZY]: "众邮快递",

  [LogisticsCompany.JDKY]: "京东快运",

  [LogisticsCompany.YUNDA_DTD]: "韵达点通达",

  [LogisticsCompany.BSYP]: "百世云配",

  [LogisticsCompany.WTO]: "运通速运",

  [LogisticsCompany.WOWVIP]: "沃埃家",

  [LogisticsCompany.TTWLKD]: "淘特物流快递",

  [LogisticsCompany.STE56]: "速腾快递",

  [LogisticsCompany.SFKY]: "顺丰快运",

  [LogisticsCompany.ANDE]: "安得物流",

  [LogisticsCompany.BESTGJ]: "百世国际",

  [LogisticsCompany.DANGDANG]: "当当网",

  [LogisticsCompany.EWE]: "EWE全球快递",

  [LogisticsCompany.FYP]: "丰云配",

  [LogisticsCompany.GJWL]: "高捷物流",

  [LogisticsCompany.HYWL]: "空港宏远电商物流",

  [LogisticsCompany.KXTX]: "卡行天下快运",

  [LogisticsCompany.RRS]: "日日顺",

  [LogisticsCompany.STO56]: "申通快运",

  [LogisticsCompany.STOGJ]: "申通国际",

  [LogisticsCompany.WSKD]: "威盛快递",

  [LogisticsCompany.WSPY]: "威时沛运",

  [LogisticsCompany.XLOBO]: "贝海国际速递",

  [LogisticsCompany.YUNDAGJ]: "韵达国际",

  [LogisticsCompany.ZTOGJ]: "中通国际",

  [LogisticsCompany.ZYEHQ]: "中远e环球",

  [LogisticsCompany.ZYSF]: "转运四方物流",

  [LogisticsCompany.ZZSY]: "卓志速运",

  [LogisticsCompany.YUNDA_TC]: "韵达同城",

  [LogisticsCompany.FENGWANG]: "丰网速运",
};

export default LogisticsCompanyNameMap;
